import { PayClassificationsScreen } from '../features/payClassifications/PayClassificationsScreen';
import { TabbedItemPage } from './TabbedItemPage';

export const AwardsClassificationsPage = () => <TabbedItemPage
  itemPath="/maintenance/awards-and-classifications"
  tabContentOverrides={{ 'awards-and-classifications': <PayClassificationsScreen /> }}
/>;
